<ng-container *transloco="let t; prefix: 'group-management.panels.background-check'">
  @if (participant(); as person) {
    <app-panel-body>
      <div class="flex min-h-0 flex-1 flex-col text-sm text-primary-text">
        <div class="min-h-0 flex-1 overflow-y-auto">
          <app-content-container>
            <div class="space-y-4">
              <p>{{ t('heading', { name: person.firstname }) }}</p>

              <fieldset class="space-y-2">
                <legend class="mb-2 font-medium">{{ t('provider-label') }}</legend>

                @if (showSelfManagedOptions()) {
                  <label class="flex items-start gap-2">
                    <input
                      type="radio"
                      name="backgroundCheckType"
                      [value]="1"
                      [checked]="backgroundCheckType() === 1"
                      (change)="backgroundCheckType.set(1)"
                    />
                    <span>{{ t('self-managed') }}</span>
                  </label>
                }

                @if (showSterlingOption()) {
                  <label class="flex items-start gap-2">
                    <input
                      type="radio"
                      name="backgroundCheckType"
                      [value]="2"
                      [checked]="backgroundCheckType() === 2"
                      (change)="backgroundCheckType.set(2)"
                    />
                    <span>{{ t('sterling') }}</span>
                  </label>
                }

                @if (waivedOption().visible) {
                  <label class="flex items-start gap-2">
                    <input
                      type="radio"
                      name="backgroundCheckType"
                      [value]="3"
                      [checked]="backgroundCheckType() === 3"
                      [disabled]="waivedOption().disabled"
                      (change)="backgroundCheckType.set(3)"
                    />
                    <span>{{ t('waived') }}</span>
                  </label>
                }
              </fieldset>

              @if (showDateField()) {
                <div>
                  <label class="mb-1 block font-medium" for="background-check-date">
                    {{ t('date-label') }}
                  </label>
                  <input
                    id="background-check-date"
                    type="date"
                    class="w-full rounded-md border border-primary-border bg-primary-bg px-3 py-2 text-sm text-primary-text"
                    [max]="maxBackgroundCheckDate"
                    [ngModel]="backgroundCheckDate()"
                    (ngModelChange)="backgroundCheckDate.set($event)"
                  />
                </div>
              }
            </div>
          </app-content-container>
        </div>

        <div class="flex shrink-0 justify-end gap-3 border-t border-primary-border px-4 py-4">
          <button
            type="button"
            class="rounded-md border border-primary-border bg-primary-bg px-4 py-2 text-sm font-semibold text-primary-text hover:bg-secondary-bg"
            (click)="cancel()"
            [disabled]="submitting()"
          >
            {{ t('cancel') }}
          </button>
          <button
            type="button"
            class="rounded-md bg-teal px-4 py-2 text-sm font-semibold text-white hover:bg-teal-600 disabled:opacity-50"
            (click)="save()"
            [disabled]="submitting()"
          >
            {{ t('save') }}
          </button>
        </div>
      </div>
    </app-panel-body>
  }
</ng-container>
